// extracted by mini-css-extract-plugin
export default {"vesselList":"vessel_list_vesselList__Ig-FP","Mui-focused":"vessel_list_Mui-focused__qCMF8","label":"vessel_list_label__e-Rkg"};